import { render, staticRenderFns } from "./VaimoTopHeaderMobile.vue?vue&type=template&id=3843ceda&scoped=true&"
import script from "./VaimoTopHeaderMobile.vue?vue&type=script&lang=ts&"
export * from "./VaimoTopHeaderMobile.vue?vue&type=script&lang=ts&"
import style0 from "./VaimoTopHeaderMobile.vue?vue&type=style&index=0&id=3843ceda&prod&lang=scss&"
import style1 from "./VaimoTopHeaderMobile.vue?vue&type=style&index=1&id=3843ceda&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3843ceda",
  null
  
)

export default component.exports